import { createActionCreator } from 'deox';

import { TResetPasswordBody, TResetPasswordResponse } from '@/services/api/auth';
import message from '@/utils/message';

// CONSTANTS

export enum EResetPasswordAction {
  RESET_PASSWORD = 'RESET_PASSWORD',
  RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED',
}

// TYPES

export type TResetPasswordRequest = {
  type: EResetPasswordAction.RESET_PASSWORD_REQUEST;
  payload: {
    materials: TResetPasswordBody;
    successCallback?: (response: TResetPasswordResponse) => void;
    failedCallback?: (err: unknown) => void;
  };
};

export type TResetPasswordSuccess = {
  type: EResetPasswordAction.RESET_PASSWORD_SUCCESS;
  payload: { response: TResetPasswordResponse };
};

export type TResetPasswordFailed = { type: EResetPasswordAction.RESET_PASSWORD_FAILED };

// FUNCTION

export const resetPasswordAction = {
  request: createActionCreator(
    EResetPasswordAction.RESET_PASSWORD_REQUEST,
    (resolve) =>
      (
        materials: TResetPasswordBody,
        successCallback?: (response: TResetPasswordResponse) => void,
        failedCallback?: (err: unknown) => void,
      ): TResetPasswordRequest => {
        return resolve({ materials, successCallback, failedCallback });
      },
  ),
  success: createActionCreator(
    EResetPasswordAction.RESET_PASSWORD_SUCCESS,
    (resolve) =>
      (response: TResetPasswordResponse): TResetPasswordSuccess => {
        return resolve({ response });
      },
  ),
  failure: createActionCreator(
    EResetPasswordAction.RESET_PASSWORD_FAILED,
    (resolve) =>
      (error: any): TResetPasswordFailed => {
        message.error('RESET_PASSWORD_FAILED Action:', error?.data.status_message);

        return resolve({ error });
      },
  ),
};
